import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Box, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { setToastMessage } from '@stores/App/slice';
import { TOAST_TYPES } from '@constants/constants';

interface AdjustInformationProps {
  accessEmail: string | undefined;
  handleScrollTo: (sidePanelId: string) => void;
}

const AdjustInformation: FC<AdjustInformationProps> = ({ accessEmail, handleScrollTo }) => {
  const dispatch = useDispatch();
  const handleCopyToClipboard = (text: string) => {
    dispatch(
      setToastMessage({
        type: TOAST_TYPES.SUCCESS,
        message: 'Copied',
      }),
    );
    navigator.clipboard.writeText(text);
  };
  return (
    <Stack gap={'1rem'}>
      <Typography
        fontSize={'0.875rem'}
        lineHeight={'1.25rem'}
        fontWeight={500}
        color={'#6C6C6C'}
        maxWidth={'100%'}
      >
        Please provide access to the above Adjust account with the Role as "Reader" to the following
        email address and confirm. Once access is granted, let us know by clicking on “Confirm
        Access” button, so we can proceed with the{' '}
        <Typography
          onClick={() => handleScrollTo('data-we-connect')}
          component={'span'}
          fontSize={'0.875rem'}
          lineHeight={'1.25rem'}
          fontWeight={700}
          color={'#51B8B0'}
          sx={{
            textDecoration: 'underline',
            ':hover': {
              cursor: 'pointer',
              textDecoration: 'none',
            },
          }}
        >
          data evaluation
        </Typography>
        .
      </Typography>

      {/* Email to be copied */}
      <Box
        sx={{
          background: '#2F736E1F',
          borderRadius: '0.25rem',
          padding: '0.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          width: 'fit-content',
          maxWidth: '80%',
        }}
      >
        <Typography
          fontSize={'0.75rem'}
          fontWeight={700}
          lineHeight={'1rem'}
          color={'#162936'}
          textOverflow={'ellipsis'}
          overflow={'hidden'}
          whiteSpace={'nowrap'}
        >
          {accessEmail || ''}
        </Typography>

        <ContentCopyIcon
          onClick={() => handleCopyToClipboard(accessEmail || '')}
          sx={{
            ':hover': {
              cursor: 'pointer',
            },
          }}
        ></ContentCopyIcon>
      </Box>
    </Stack>
  );
};

export default AdjustInformation;
